import * as React from 'react';

import cn from 'classnames';

import { IBrandElementCardProps } from './types';

import * as s from './BrandElementCard.scss';

export const BrandElementCard = ({
	image,
	className,
}: IBrandElementCardProps) => {
	return (
		<div
			className={cn(s.block, className)}
		>
			<div className={s.content}>
				<img
					src={image}
					className={s.image}
				/>
			</div>
		</div>
	);
};
